import * as React from "react"

const SvgRec = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.786 10.043q.685 0 1.2.514.514.515.514 1.2v1.714q0 .15-.043.322a10 10 0 0 1-.086.321L18.8 20.157a1.73 1.73 0 0 1-.643.729q-.45.3-.943.3H7.786V10.043l5.143-5.1q.32-.322.76-.375t.847.16q.407.215.6.6.193.387.085.793l-.964 3.922zM9.5 10.77v8.7h7.714l2.572-6v-1.714H12.07l1.158-4.714zM5.214 21.186a1.65 1.65 0 0 1-1.21-.504 1.65 1.65 0 0 1-.504-1.21v-7.715q0-.707.504-1.21a1.65 1.65 0 0 1 1.21-.504h2.572v1.714H5.214v7.714h2.572v1.715z" />
  </svg>
)
export default SvgRec
